import React, { useState, useRef } from "react";
import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import {
  getErrorMessageByKey,
  useNotification,
  useObject,
  Input,
  useList,
  Select,
  getAccountFio,
  jsonFormatText,
  isValidateNullText,
  Modal,
} from "@vokymlak/kabinet-ui";

function ModalCategoryInGroup(props) {
  const {
    object: [object],
  } = useObject({
    apiUrl: "/api/nomenclature-category/" + props.object.uuid,
    rootUrl: ROOT_URL,
    callbackError: () => {
      props.handleClose();
    },
  });

  const {
    list: [list],
  } = useList({ apiUrl: "/api/nomenclature-categories", rootUrl: ROOT_URL });

  const selectArticleGroupUuid = useRef(null);

  const { notification } = useNotification();

  const changeEdit = (event) => {
    event.preventDefault();

    const articleGroupUuid = selectArticleGroupUuid.current.value;

    axios
      .get("/api/nomenclature-category/" + props.object.uuid + "/in-category-group/" + articleGroupUuid, {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Данные сохранены", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const getSelectOptions = (list) => {
    const options = [
      {
        value: "null",
        title: "Не выбрано",
      },
    ];

    list.map((item) => {
      if (item.nomenclature_category_type.tag === "GROUP_CATEGORIES") {
        const option = {
          value: item.uuid,
          title: item.title,
        };

        options.push(option);
      }
    });

    return options;
  };

  return (
    !!object &&
    !!list && (
      <Modal handleClose={() => props.handleClose()}>
          <form className="Form" onSubmit={(event) => changeEdit(event)}>
            <div className="Form__title">
              {object.title}
              <div className="Text__signature">Перенести в группу</div>
            </div>

            <div className="Form__field Form__field_last">
              <Select
                reference={selectArticleGroupUuid}
                isFixed={true}
                options={!!list ? getSelectOptions(list) : getSelectOptions([])}
                label="Группа категорий"
              />
            </div>

            <div className="Form__actions Form__actions_center">
              <button className="Action__button Action__button_all Action__button_blue">
                Перенести
              </button>
            </div>
          </form>
      </Modal>
    )
  );
}

export default ModalCategoryInGroup;
